import React from "react";

import { Disclosure } from "@headlessui/react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import AuthenticationService from "../../services/AuthenticationService";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const MenuDropdown = ({ name, Icon, dropdown }) => {
  const { pathname } = useLocation();
  const scopes = AuthenticationService.getUserScopes();

  if (!dropdown?.length) {
    return null;
  }

  const active = dropdown.reduce(
    (acc, { href }) => (!acc && pathname.indexOf(href) >= 0 ? true : acc),
    false
  );

  return (
    <Disclosure as="div" key={name} className="space-y-1">
      {({ open }) => (
        <>
          <Disclosure.Button
            className={classNames(
              active
                ? "bg-gray-200 text-gray-900"
                : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
              "group w-full flex items-center justify-between px-2 py-2 text-base font-medium rounded-md"
            )}
          >
            <div className="flex items-center">
              <Icon
                className="mr-3 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                aria-hidden="true"
              />
              <span className="flex-1">{name}</span>
            </div>
            <svg
              className={classNames(
                open ? "text-gray-400 rotate-90" : "text-gray-300",
                "ml-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150"
              )}
              viewBox="0 0 20 20"
              aria-hidden="true"
            >
              <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
            </svg>
          </Disclosure.Button>
          <Disclosure.Panel className="space-y-1">
            {dropdown
              .filter((item) => {
                if (!item.scopes) {
                  return true;
                }

                if (item.scopes.some((r) => scopes.indexOf(r) >= 0)) {
                  return true;
                }

                return false;
              })
              .map((subItem) => {
                const subActive = pathname.indexOf(subItem.href) >= 0;

                return (
                  <Link
                    key={subItem.name}
                    to={subItem.href}
                    className={classNames(
                      subActive ? "bg-gray-50" : "",
                      "group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50"
                    )}
                  >
                    {subItem.name}
                  </Link>
                );
              })}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default MenuDropdown;
